import React from 'react'
import { useTranslation } from 'react-i18next';

import napaLogo from '../../assets/napaLogo.svg'
import altromLogo from '../../assets/altromLogo.svg'
// import logoFr from '../../assets/logo_fr.png'
import { useCompany } from '../../hooks/company'

import './unauthorized.scss'

export default function Unauthorized({ children }) {

    const { i18n } = useTranslation()
    const company = useCompany()

    const logos = {
        "NAPA": {
            "en": napaLogo,
            "fr": napaLogo
        },
        "AAG": {
            "en": altromLogo,
            "fr": altromLogo
        }
    }

    const logo = logos[company][i18n.language]

    return(
        <div className='unauthorizedContainer'>
            <div className='unauthorizedContent'>
                <div className='unauthorizedContainerPadding'>
                    <div className='unauthorizedLogo'>
                        <img src={ logo } alt={`${ company === "NAPA" ? "NAPA" : "Altrom" }`} />
                    </div>
                    <div className='unauthorizedForm'>
                        { children }
                    </div>
                </div>
            </div>
        </div>
    )

}